import moment from 'moment-timezone';

// Regex to match predefine folder name in file name. Match string will be like this "Input, input, etc"
const folderNameRegexForPath = /(input|Input|PreProcessed|Processed|system-imported)([\/\\]+)/g;

// Regex to match predefine folder name in file name. Match string will be like this "Input, input, etc"
const folderNameRegex = /(input|Input|PreProcessed|Processed|system-imported)\/+/g;

// Regex to match file name with timestamp in the end. Match string will be like this "_2021-03-17T07-51-40"
const multiplePostfixTimeStampRegex = /_\d{4}-\d{2}-\d{2}T\d{2}-\d{2}-\d{2}/g;

/**
 * Remove timestamp from file name and convert time field into ISO string
 * @param {object[]} files file list
 */
function modifyFileObject(files, isHistory) {
  return files.map((file, index) => {
    let fileName = file.FileName;

    // Remove all postfix timestamp ["_2021-03-17T07-51-40"]
    fileName = fileName.replace(multiplePostfixTimeStampRegex, '');
    // Remove folder(input|Input|PreProcessed|Processed)
    fileName = fileName.replace(folderNameRegex, '');

    const filePath = file.FilePath?.replace(multiplePostfixTimeStampRegex, '').replace(folderNameRegexForPath, '');

    return {
      ...file,
      Id: index,
      DisplayFileName: fileName,
      DisplayFileNameV3: isHistory ? filePath.replace(/\\+/g, '/') : filePath,
      ModifiedDate: moment(file.ModifiedDate).toISOString()
    };
  });
}

export const mutations = {
  setDatasetFiles(state, { tablesCount, files, reset = true }) {
    state.tablesCount = tablesCount || tablesCount === 0 ? tablesCount : state.tablesCount;
    // Push files in list as we are fetching files in batch
    if (files.length > 0) {
      const uploadedFiles = modifyFileObject(files);
      state.uploadedFiles.push(...uploadedFiles);
    } else if (reset) {
      state.uploadedFiles = [];
    }
  },
  setUploadFiles(state, fileArray = []) {
    state.files = fileArray;
  },
  setReload(state, isReload) {
    state.reload = isReload;
  },
  setImportTabIndex(state, index) {
    state.importTabIndex = index;
    state.jobHistoryRecords = {};
  },
  setFileNameWarning(state, value) {
    state.fileNameWarning = value;
  },
  setUnsupportedFiles(state, files = []) {
    state.unsupportedFiles = files;
  },
  /**
   * Filter out file which contains unsupported characters in fileName
   * @param {object[]} files List of files to be uploaded
   */
  filterUnsupportedFiles(state, { files, fileNameProperty = 'FileName' }) {
    const filterFiles = files
      .filter((file) =>
        /[`#%^*|?;:'"<>[\]\\/]/g.test(file[fileNameProperty].substring(file[fileNameProperty].lastIndexOf('/') + 1))
      )
      .map((file) => file[fileNameProperty]);

    if (filterFiles.length) {
      state.unsupportedFiles = filterFiles;
      state.fileNameWarning = true;
    }
  },
  setJobHistoryRecords(state, { records }) {
    const modifiedData = records.data.map((record) => {
      const params = record.Params || {};
      // Remove timestamp from file name
      params.table = (params.table || '').replace(multiplePostfixTimeStampRegex, '');
      try {
        const msg = JSON.parse(record.RetryMessages);
        if (Array.isArray(msg)) {
          record.formattedMsg = msg;
        }
      } catch (e) {
        // Do nothing if error occurred
      }
      return {
        ...record,
        Params: params
      };
    });
    state.jobHistoryRecords = {
      recordsFiltered: records.recordsFiltered,
      recordsTotal: records.recordsTotal,
      data: modifiedData
    };
  },
  setFilesInImport(state, files = []) {
    const filesInImport = state.filesInImport.concat(files);
    state.filesInImport = filesInImport.filter((file, index, array) => array.indexOf(file) === index);
  },
  resetFilesInImport(state, files = []) {
    state.filesInImport = state.filesInImport.filter((file) => !files.includes(file));
  },
  setDatasetHistoryFiles(state, { records, count, reset = true }) {
    // Push files in list as we are fetching files in batch
    if (records.length > 0) {
      state.datasetHistoryFiles = { records: modifyFileObject(records, true), count };
    } else if (reset) {
      state.datasetHistoryFiles = { records: [], count: 0 };
    }
  },
  setHistoryReload(state, isReload) {
    state.historyReload = isReload;
  }
};
